import React from "react";
import { TreeSelect } from "@weezevent/nacre";
import PropTypes from "prop-types";

/**
 * TreeSelect expects a value as an array [parentId, childId] to keep the hierarchy,
 * but this component allows using a single value while maintaining compatibility.
 */
export const SingleValueTreeSelect = ({
	onChange,
	value,
	data,
	defaultValue,
	...restProps
}) => {
	const getValueFromArray = singleValue => {
		if (!singleValue || !data || !data.length) return [];

		for (const category of data) {
			const matchingChild = category.children?.find(
				child => child.value === singleValue
			);
			if (matchingChild) {
				return [category.value, matchingChild.value];
			}
		}

		return [];
	};

	const handleChange = valueArray => {
		if (
			!valueArray ||
			!Array.isArray(valueArray) ||
			valueArray.length < 2
		) {
			onChange && onChange(null);
			return;
		}

		// Extract the leaf node value (last item in array)
		const singleValue = valueArray[valueArray.length - 1];
		onChange && onChange(singleValue);
	};

	// Convert single value to array format for TreeSelect
	const treeSelectValue = getValueFromArray(value);
	const defaultValueArray = getValueFromArray(defaultValue);
	return (
		<TreeSelect
			onChange={handleChange}
			value={treeSelectValue}
			data={data}
			defaultValue={defaultValueArray}
			disableReset
			{...restProps}
		/>
	);
};

SingleValueTreeSelect.propTypes = {
	onChange: PropTypes.func.isRequired,
	value: PropTypes.string.isRequired,
	defaultValue: PropTypes.string,
	data: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
				.isRequired,
			text: PropTypes.string.isRequired,
			children: PropTypes.arrayOf(
				PropTypes.shape({
					value: PropTypes.oneOfType([
						PropTypes.string,
						PropTypes.number
					]).isRequired,
					text: PropTypes.string.isRequired
				})
			)
		})
	).isRequired
};

SingleValueTreeSelect.defaultProps = {
	defaultValue: null
};

export default SingleValueTreeSelect;
